function revertClickableRegionsStyle(map){
    map.data.forEach(feature => {
        var clickable = feature.getProperty("clickable");
        if (clickable) {
            map.data.overrideStyle(feature, { fillOpacity: 1.0 });
            map.data.overrideStyle(feature, { strokeOpacity: 0.0 });
        }
    });
}

function setClickableRegions(regions, map){
    regions.forEach(region => {
        var latlng = new google.maps.LatLng(region.Lat, region.Long);

        map.data.forEach(feature => {
            if (isLatLngInFeatureGeometry(latlng, feature)) {
                feature.setProperty("clickable", true);
                feature.setProperty("regionId", region.Id);
                map.data.overrideStyle(feature, { fillOpacity: 1.0 });
            }
        });
    });
}

function isLatLngInFeatureGeometry(latlng, feature) {
    var isInside = false;
    if (feature.getProperty("type") === "Polygon") {
        var paths = feature.getGeometry().getAt(0).getArray();
        if (isLatLngInPoly(latlng, paths)) {
            isInside = true;
        }
    } else if (feature.getProperty("type") === "MultiPolygon") {
        var lineStringArray = feature.getGeometry().getArray();
        lineStringArray.forEach(lineString => {
            var paths = [];
            lineString.forEachLatLng(latlng => {
                paths.push(latlng);
            });
            if (isLatLngInPoly(latlng, paths)) {
                isInside = true;
            }
        });
    }

    return isInside;
}

function isLatLngInPoly(latlng, paths) {
    var poly = new google.maps.Polygon({
        paths: paths
    });
    if (google.maps.geometry.poly.containsLocation(latlng, poly)) {
        return true;
    }
    return false;
}

export { revertClickableRegionsStyle, setClickableRegions };